import selectors from '@/redux/selectors/selectors';
import { useSelector } from 'react-redux';
import ErrorSplash from './ErrorSplash';

const SplashScreenHandler = () => {
  const { open } = useSelector(selectors.errorSplashScreen);

  if (!open) {
    return null;
  }

  return <ErrorSplash />;
};

export default SplashScreenHandler;
